// extracted by mini-css-extract-plugin
export default {"wrap":"ListViewLoader-wrap","stacked":"ListViewLoader-stacked","stackedColumn":"ListViewLoader-stackedColumn","placeholder":"ListViewLoader-placeholder"};